<template>
  <section class="section-terms text-remark">
    <hr class="booking-divider">
    <div id="accordion">
      <div class="card shadow-sm">
        <div class="card-header" id="headingOne">
          <h5 class="mb-0">
            <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                    aria-controls="collapseOne">
              {{ $t('message.booking.payment_step.terms_and_conditions') }}
            </button>
          </h5>
        </div>

        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
          <div class="card-body">
            <ul class="maininfo-list">
              <li>{{ $t('message.booking.checkout_step.terms_and_conditions01') }}</li>
              <li>{{ $t('message.booking.checkout_step.terms_and_conditions02') }}</li>
              <li v-if="preBookingData.service_id === 1">
                <span v-html="$t('message.booking.checkout_step.terms_and_conditions03')"></span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="card shadow-sm">
        <div class="card-header" id="headingTwo">
          <h5 class="mb-0">
            <button class="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo"
                    aria-expanded="false" aria-controls="collapseTwo">
              {{ $t('message.booking.checkout_step.policy') }}
            </button>
          </h5>
        </div>
        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
          <div class="card-body">
            <ul class="maininfo-list">
              <li>{{ $t('message.booking.checkout_step.policy01') }}</li>
              <li>{{ $t('message.booking.checkout_step.policy02') }}</li>
              <li>{{ $t('message.booking.checkout_step.policy03') }}</li>
              <li>{{ $t('message.booking.checkout_step.policy04') }}</li>
              <li>{{ $t('message.booking.checkout_step.policy05') }}</li>
              <li>{{ $t('message.booking.checkout_step.policy06') }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Ac cleaning service remark -->
    <div class="card" v-if="preBookingData.service_items">
      <div class="card-body text-info">
        {{ $t('message.service_item.checkout_remark') }}
      </div>
    </div>

    <div class="mt-3 custom-control custom-checkbox">
      <input id="acceptTerms"
             type="checkbox"
             name="acceptTerms"
             class="custom-control-input"
             value="true"
             @change="acceptTC"
             v-validate="'required'">
      <label for="acceptTerms" class="custom-control-label">
        {{ $t('message.booking.checkout_step.accept_conditions01') }}
        {{ $t('message.booking.checkout_step.accept_conditions02') }}
        {{ $t('message.booking.checkout_step.accept_conditions03') }}
        {{ $t('message.booking.checkout_step.accept_conditions04') }}
        <a href="/term" target="_blank">
          <u>{{ $t('message.booking.checkout_step.learn_more') }}</u>
        </a>
      </label>
    </div>
    <div class="mt-1 text-remark -status-alert" v-if="errors.has('acceptTerms')">
      <i class="fas fa-exclamation-triangle"></i> {{ $t('message.required_selection') }}
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    inject: ['$validator'],
    computed: {
      ...mapGetters({
        preBookingData: 'booking/getPreBookingData'
      })
    },
    methods: {
      acceptTC (event) {
        const status = event.target.checked
        // console.log('acceptTC', status)
        this.$store.commit('booking/SET_ACCEPT_TERMS_CONDITIONS', status)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/TermsConditions.vue